import window from '../injectChromeObject'

export const isInExtension = (): boolean => Boolean(window.chrome?.runtime?.id)

/*
 * @deprecated
 * Use isChrome() from @mote/helpers/browser instead.
 *
 * */
export function isExtensionSupported(): boolean {
  return /Chrome/.test(navigator.userAgent)
}
